import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenStorageService } from '@lmc-app/core/services/token-storage.service';

/**
 * HTTP Interceptor to add Authorization Bearer token to all HTTP requests.
 * Reads the access token from TokenStorageService (localStorage-backed).
 */
@Injectable()
export class CredentialsInterceptor implements HttpInterceptor {
	constructor(private readonly tokenStorage: TokenStorageService) {}

	intercept(
		request: HttpRequest<unknown>,
		next: HttpHandler
	): Observable<HttpEvent<unknown>> {
		const token = this.tokenStorage.getAccessToken();

		if (token) {
			const modifiedRequest = request.clone({
				setHeaders: {
					Authorization: `Bearer ${token}`
				}
			});
			return next.handle(modifiedRequest);
		}

		return next.handle(request);
	}
}